/**
 * @packageDocumentation
 * @module      MsalStateMachine.ts
 * @description Checks the state of MSAL redirection.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { createMachine } from 'xstate';
export const MSALredirectionStateMachine = createMachine({
    id: 'msalRedirection',
    initial: 'loading',
    states: {
        loading: {
            on: {
                LOGIN_SUCCESS: 'login_success',
                LOGIN_FAILURE: 'login_failure',
                HANDLE_REDIRECT_END: 'in_login'
            }
        },
        in_login: {
            type: 'final'
        },
        login_success: {
            type: 'final'
        },
        login_failure: {
            type: 'final'
        }
    }
});
export function dispatchEventToMSALComponent(state) {
    var _a;
    (_a = document.querySelector("msal-component")) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('msalStateChanged', { detail: state }));
}
const stateNodesAndStateValues = new Map();
stateNodesAndStateValues.set(MSALredirectionStateMachine.states.loading, "loading");
stateNodesAndStateValues.set(MSALredirectionStateMachine.states.in_login, "in_login");
stateNodesAndStateValues.set(MSALredirectionStateMachine.states.login_failure, "login_failure");
stateNodesAndStateValues.set(MSALredirectionStateMachine.states.login_success, "login_success");
export function getStateValueForStateNode(stateNode) {
    return stateNodesAndStateValues.get(stateNode);
}
//# sourceMappingURL=MsalStateMachine.js.map